import { Box, Typography } from '@mui/material';

const TabHeaderTypography = ({ title, highlight }) => (
  <Box>
    <Typography variant="h4" component="div">
      {title} <span style={{ color: '#4179E1' }}>{highlight}</span>
    </Typography>
  </Box>
);

export default TabHeaderTypography;
